import styled from 'styled-components';

export const Container = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  padding: 4px 4px 4px 0;
  border-radius: 4px;
  width: 100%;

  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #161d1f;
    text-align: left;
  }

  .checkbox-wrapper {
    position: relative;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;

    input {
      width: 16px;
      height: 16px;
      opacity: 0;
      position: absolute;
      cursor: pointer;
      z-index: 2;
    }

    .custom-checkbox {
      width: 16px;
      height: 16px;
      border-radius: 2px;
      background-color: transparent;
      border: 2px solid #283044;
      position: absolute;
      pointer-events: none;
      z-index: 1;
    }

    input:checked + .custom-checkbox {
      background-color: #745ef6;
      border: none;
    }

    input:checked + .custom-checkbox::after {
      content: '';
      position: absolute;
      top: 3px;
      left: 6px;
      width: 4px;
      height: 8px;
      border: solid white;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }

    .hover-ring {
      position: absolute;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background-color: transparent;
      transition: background-color 0.2s;
      pointer-events: none;
      z-index: 0;
    }

    input:hover:not(:checked) ~ .hover-ring {
      background-color: #d5e5f0; // Hover sin check
    }
    input:active:not(:checked) ~ .hover-ring {
      background-color: #a8cbe2;
    }
    input:focus:not(:checked) ~ .hover-ring {
      background-color: #a8cbe2;
    }

    input:hover ~ .hover-ring {
      background-color: #e2dffd;
    }
    input:active ~ .hover-ring {
      background-color: #c6c0fc;
    }
    input:focus ~ .hover-ring {
      background-color: #c6c0fc;
    }
  }
`;
